module.exports = __webpack_public_path__ + "static/img/default_code.49f48a4a.jpg";